import { ChangeEvent } from 'react';

import campaignsDashboardCampaignCheckboxButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaigns_dashboard/campaigns_dashboard_campaign_checkbox_button_click';

import { getIsCampaignNeedShowCheckbox } from 'components/CampaignsDashboard/utils/utils';

import { DashboardCampaign, setCheckedCampaignIds } from 'store/models/campaignsDashboard';
import { useDispatch, useSelector } from 'store/utils';

export const useCampaignSelection = (
    campaign: DashboardCampaign,
    isMutatingActionAvailable: boolean
): {
    isChecked: boolean;
    isSelectionAvailable: boolean;
    onSelectionChange: (event: ChangeEvent<HTMLInputElement>) => void;
} => {
    const { id, frontendStatus, budget } = campaign;
    const checkedCampaignIds = useSelector((state) => state.campaignsDashboard.checkedCampaignIds);
    const isChecked = checkedCampaignIds.has(id);
    const dispatch = useDispatch();

    const isSelectionAvailable = getIsCampaignNeedShowCheckbox(frontendStatus, budget, isMutatingActionAvailable);

    const onSelectionChange = (event: ChangeEvent<HTMLInputElement>) => {
        const newCheckedCampaignIds = new Set(checkedCampaignIds);
        const checked = event.target.checked;

        if (checked) {
            newCheckedCampaignIds.add(id);
        } else {
            newCheckedCampaignIds.delete(id);
        }

        campaignsDashboardCampaignCheckboxButtonClick({
            campaignId: id,
            checkedCampaignIds: [...newCheckedCampaignIds].toString(),
        });
        dispatch(setCheckedCampaignIds(newCheckedCampaignIds));
    };

    return { isChecked, isSelectionAvailable, onSelectionChange };
};
